module.exports = __webpack_public_path__ + "img/ch55.81d35586.jpg";